<template>
  <section class="main-header">
    <Navigator />
    <BannerInfoPage
      :bannerData="bannerData"
    />
  </section>
</template>

<script>
import Navigator from './Navigator'
import BannerInfoPage from './BannerInfoPage'

export default {
  name: 'Header',
  components: {
    Navigator,
    BannerInfoPage
  },
  props: ['bannerData'],
  data () {
    return {
    }
  }
}
</script>
